import { useState } from 'react';

export default function Hero() {
  const [showDemoModal, setShowDemoModal] = useState(false);

  const scrollToServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex flex-col px-8 pt-24">
      <div className="absolute inset-8 rounded-[40px] overflow-hidden bg-black">
        <img
          src="https://static.readdy.ai/image/a9484c237c280a31654c8c92f5f19b1a/019be4b6e99dcc252237705f2fbab046.png"
          alt="Patriot Defense MSP"
          className="w-full h-full object-contain"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 flex-1 flex items-center justify-center">
        <div className="text-center max-w-4xl mx-auto">
          {/* Heading removed */}
        </div>
      </div>

      <div className="relative z-10 pb-8 sm:pb-16 pl-2 sm:pl-8">
        <div className="flex flex-col sm:flex-row items-start gap-3 sm:gap-4">
          <button 
            onClick={scrollToServices}
            className="px-6 sm:px-8 py-3 sm:py-4 bg-white text-[#0066CC] rounded-lg font-semibold text-sm sm:text-base hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore Solutions
          </button>
          <button 
            onClick={() => setShowDemoModal(true)}
            className="px-6 sm:px-8 py-3 sm:py-4 border-2 border-white text-white rounded-lg font-semibold text-sm sm:text-base hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
          >
            Watch Demo
          </button>
        </div>
      </div>

      {/* Demo Video Modal */}
      {showDemoModal && (
        <div 
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-3 sm:p-4"
          onClick={() => setShowDemoModal(false)}
        >
          <div 
            className="bg-[#1A2332] rounded-2xl max-w-4xl w-full shadow-2xl overflow-hidden max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Header */}
            <div className="flex items-center justify-between p-4 sm:p-6 border-b border-white/10">
              <div>
                <h3 className="text-lg sm:text-xl font-bold text-white">See How We Transform Businesses</h3>
                <p className="text-white/60 text-xs sm:text-sm mt-1">Discover our comprehensive IT solutions in action</p>
              </div>
              <button 
                onClick={() => setShowDemoModal(false)}
                className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors cursor-pointer flex-shrink-0 ml-2"
              >
                <i className="ri-close-line text-2xl text-white"></i>
              </button>
            </div>

            {/* Video Placeholder */}
            <div className="relative aspect-video bg-black">
              <img
                src="https://public.readdy.ai/ai/img_res/7cf6394354d3f8f3596c07d698f27705.jpg"
                alt="Demo Video"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black/30">
                <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center cursor-pointer hover:bg-white/30 transition-colors">
                  <i className="ri-play-fill text-3xl sm:text-4xl text-white ml-1"></i>
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="p-4 sm:p-6 bg-gradient-to-r from-[#0066CC]/20 to-transparent">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#0066CC] flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-2-line text-white"></i>
                  </div>
                  <div>
                    <p className="text-white font-medium text-sm sm:text-base">Ready to get started?</p>
                    <p className="text-white/60 text-xs sm:text-sm">Schedule a personalized demo with our team</p>
                  </div>
                </div>
                <a 
                  href="https://outlook.office.com/bookwithme/user/5d555848c5b146038f69a8fa5f341205@patriotdt.com?anonymous&ismsaljsauthenabled&ep=plink"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-6 py-3 bg-[#0066CC] text-white rounded-lg font-semibold text-sm hover:bg-[#0055AA] transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto text-center"
                >
                  Schedule Live Demo
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
